export default __webpack_public_path__ + "static/Ogg-Regular-77698e04b45570ccb89f844933982a62.ttf";